/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleSourceCategoryFromJSON, ApiSimpleSourceCategoryToJSON, } from './ApiSimpleSourceCategory';
export function ApiReadSourceCategoryResponseFromJSON(json) {
    return ApiReadSourceCategoryResponseFromJSONTyped(json, false);
}
export function ApiReadSourceCategoryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': !exists(json, 'category') ? undefined : ApiSimpleSourceCategoryFromJSON(json['category']),
    };
}
export function ApiReadSourceCategoryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': ApiSimpleSourceCategoryToJSON(value.category),
    };
}
